import React from "react";
import { Card } from "..";
import styles from "./styles.module.scss";
import {
  ActiveStudioIcon,
  ConnectedComputersIcon,
  DisconnectedComputersIcon,
  PaidStrikersIcon,
  TotalFreeStrikersIcon,
} from "icons";

const list = [
  {
    id: 1,
    label: "Total Tickets",
    value: 260,
    Icon: ActiveStudioIcon,
    info: "Total Tickets",
  },
  {
    id: 2,
    label: "Pending Tickets",
    value: 260,
    Icon: ConnectedComputersIcon,
    info: "Pending Tickets",
  },
  {
    id: 3,
    label: "Open Tickets",
    value: 260,
    Icon: DisconnectedComputersIcon,
    info: "Open Tickets",
  },
  {
    id: 4,
    label: "Closed Tickets",
    value: 260,
    Icon: PaidStrikersIcon,
    info: "Closed Tickets",
  },
];

export const ListOfCards = () => {
  return (
    <div className={styles.listContainer}>
      {list.map((item) => (
        <Card key={item.id} item={item} />
      ))}
    </div>
  );
};
